import WhatsAppImg from './WhatsApp.png';
import cookies from "../../utils/cookies";

export default function WhatsAppButton() {
  const agentInfo = cookies.getAgentInfo();
  
  const open = () => {
    window.open(agentInfo.whatsappUrl);
  };
  
  return (
    agentInfo.whatsappUrl &&
    <a className="fixed right-[20px] bottom-[50px] cursor-pointer z-50" onClick={open}>
      <img src={WhatsAppImg} className="w-[52px] h-[52px] mdmax:w-[40px] mdmax:h-[40px]"/>
    </a>
  );
}
